var map = {
	"./activity/icon-activity.svg": "df9e",
	"./activity/icon-completed-task.svg": "5779",
	"./activity/icon-contract-sent.svg": "c2f0",
	"./activity/icon-contract.svg": "10ba",
	"./activity/icon-download-contract.svg": "0a6e",
	"./activity/icon-hour-glass.svg": "b0dc",
	"./activity/icon-no-history.svg": "e1d6",
	"./activity/icon-no-project.svg": "f0a2",
	"./activity/icon-no-voucher.svg": "1bbb",
	"./activity/icon-project-end.svg": "9f09",
	"./activity/icon-project.png": "6503",
	"./activity/icon-project.svg": "5e10",
	"./activity/icon-tab-1.svg": "fe12",
	"./activity/icon-tab-2.svg": "2f61",
	"./activity/icon-tab-3.svg": "a6d9",
	"./activity/icon-time-warn.svg": "97a9",
	"./activity/icon-voucher-sent.svg": "67ee",
	"./appliances/icon-ac.svg": "c7ae",
	"./appliances/icon-battery.svg": "3444",
	"./appliances/icon-chaleira.svg": "ca31",
	"./appliances/icon-coffee.svg": "31a6",
	"./appliances/icon-desu.svg": "e620",
	"./appliances/icon-dry.svg": "1e89",
	"./appliances/icon-eel.svg": "5108",
	"./appliances/icon-fotov.svg": "bcd3",
	"./appliances/icon-freezer.svg": "5057",
	"./appliances/icon-frig-1.svg": "aff6",
	"./appliances/icon-frig-2.svg": "f1be",
	"./appliances/icon-grill.svg": "bf09",
	"./appliances/icon-heat.svg": "f509",
	"./appliances/icon-induc.svg": "6f63",
	"./appliances/icon-light.svg": "5cfc",
	"./appliances/icon-misc.svg": "cf41",
	"./appliances/icon-multi.svg": "a2f8",
	"./appliances/icon-mw.svg": "0180",
	"./appliances/icon-oven.svg": "83c3",
	"./appliances/icon-radiator.svg": "c7fc",
	"./appliances/icon-robot.svg": "14f0",
	"./appliances/icon-termoa.svg": "83cc",
	"./appliances/icon-termossifao.svg": "39a6",
	"./appliances/icon-termov.svg": "490e",
	"./appliances/icon-toast.svg": "ecf5",
	"./appliances/icon-tv.svg": "3d3a",
	"./appliances/icon-ve.svg": "020a",
	"./appliances/icon-wine-freezer.svg": "2c41",
	"./appliances/icon-wm-1.svg": "4d10",
	"./appliances/icon-wm-2.svg": "2ba4",
	"./dashboard/icon-active-time.svg": "7819",
	"./dashboard/icon-avg-consumption.svg": "2ca9",
	"./dashboard/icon-rt-consumption.svg": "8b59",
	"./icon-404.svg": "d58c",
	"./icon-appliance-default.svg": "faef",
	"./icon-appliances.svg": "3c20",
	"./icon-attributed-credits.svg": "2655",
	"./icon-back-arrow.svg": "3e7f",
	"./icon-bell-selected.svg": "e5c9",
	"./icon-bell.svg": "7744",
	"./icon-btn-minus.svg": "d84f",
	"./icon-btn-plus.svg": "a830",
	"./icon-callendar.svg": "bdd3",
	"./icon-camera-reverse.svg": "071d",
	"./icon-camera.svg": "8d06",
	"./icon-caution.svg": "f9a4",
	"./icon-collapse.svg": "1dc7",
	"./icon-completed-task.png": "b590",
	"./icon-credits-missing.svg": "8ed0",
	"./icon-dashboard-modal.svg": "59af",
	"./icon-delete-btn.svg": "c112",
	"./icon-download-2--white.svg": "668f",
	"./icon-download-2.svg": "d93d",
	"./icon-download.svg": "ae39",
	"./icon-due-date.svg": "0ad7",
	"./icon-energy.svg": "26a3",
	"./icon-error--white.svg": "f2d1",
	"./icon-error.svg": "f519",
	"./icon-exit.svg": "3125",
	"./icon-file-upload-reverse.svg": "2450",
	"./icon-file-upload.svg": "0c37",
	"./icon-fluct.svg": "22c0",
	"./icon-hamburger-button.svg": "1cc9",
	"./icon-hourglass.svg": "b797",
	"./icon-information.png": "eda6",
	"./icon-launch.png": "3368",
	"./icon-moon.svg": "db99",
	"./icon-new-project.png": "f4c1",
	"./icon-new-project.svg": "26ed",
	"./icon-notifications.svg": "46dc",
	"./icon-passport-avatar.svg": "43df",
	"./icon-passport-small-avatar.svg": "7bfa",
	"./icon-policies.svg": "dde2",
	"./icon-project-launch.png": "5125",
	"./icon-project-launch.svg": "42eb",
	"./icon-project.png": "0988",
	"./icon-projects.svg": "88b7",
	"./icon-redirect.png": "7e5f",
	"./icon-review-task.png": "c4f8",
	"./icon-sent-access.svg": "c540",
	"./icon-sent-message.svg": "fd4b",
	"./icon-slack.png": "fc3d",
	"./icon-sunny.svg": "8b5b",
	"./icon-temperature.svg": "5ef2",
	"./icon-terms.svg": "73fc",
	"./icon-thank-you.svg": "b909",
	"./icon-unavailable.svg": "57aa",
	"./icon-unplugged.svg": "d8ed",
	"./icon-wallet-2.svg": "c86f",
	"./icon-wallet-disabled.svg": "241d",
	"./icon-wallet.svg": "b8b8",
	"./icon-warning.svg": "1575",
	"./icon-watch-2.svg": "d038",
	"./icon-watch.svg": "bfed",
	"./menus/icon-activities.svg": "dac4",
	"./menus/icon-consumption-statistics.svg": "8fcb",
	"./menus/icon-dashboard.svg": "8d34",
	"./menus/icon-device-monitoring.svg": "bbd9",
	"./menus/icon-interval-statistics.svg": "718d",
	"./menus/icon-lock.svg": "4fbe",
	"./menus/icon-logout.svg": "24ef",
	"./menus/icon-profile.svg": "1236",
	"./menus/icon-solar-production.svg": "3145",
	"./menus/icon-support-2.svg": "b053",
	"./menus/icon-support.svg": "6543",
	"./menus/icon-thermal-readings.svg": "db71",
	"./monitor/icon-active-sensor.svg": "83d3",
	"./monitor/icon-counter.svg": "ceeb",
	"./monitor/icon-energy-meter.svg": "3099",
	"./monitor/icon-plug.svg": "0375",
	"./monitor/icon-prod-redy.svg": "718c",
	"./monitor/icon-prod-shelly.svg": "75ac",
	"./monitor/icon-redy-small.svg": "b19f",
	"./monitor/icon-redy.svg": "8326",
	"./monitor/icon-sel-box-small.svg": "c4b3",
	"./monitor/icon-sel-box.svg": "bc40",
	"./monitor/icon-shelly-small.svg": "7784",
	"./monitor/icon-shelly.svg": "bff4",
	"./monitor/icon-state-critical.svg": "ed28",
	"./monitor/icon-state-down.svg": "c410",
	"./monitor/icon-state-up.svg": "cb41",
	"./monitor/icon-temp-sensor.svg": "115b",
	"./monitor/icon-voltaware.svg": "b5a3",
	"./rooms/icon-bedroom.svg": "b7d5",
	"./rooms/icon-kitchen.svg": "7fd1",
	"./rooms/icon-living-room.svg": "d7e5",
	"./rooms/icon-office.svg": "548e",
	"./support/icon-1.svg": "d8da",
	"./support/icon-2.svg": "d158",
	"./support/icon-3.svg": "00b9",
	"./support/icon-4.svg": "47bb",
	"./support/icon-5.svg": "8eaa"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "67f7";